import React from "react";
import { useTheme } from ".";
import useWindowDimensions from "./UseWindowDiemensions";

const useIsLaptop = () => {
    const { width } = useWindowDimensions();
    const theme = useTheme();

    const useIsLaptop = width < theme.breakpoints.values.laptop;

    return useIsLaptop;
};

export default useIsLaptop;
